import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { verifyToken } from '../../Store/Actions/Auth'
import JwtService from '../Services/JwtService'

import { VERIFIED_TOKEN } from '../../Store/Actions/Types'

const AuthInit = (props) => {
  const dispatch = useDispatch()
  // const [showSplashScreen, setShowSplashScreen] = useState(true)
  const accessToken = JwtService.getToken();

  // We should request user by authToken before rendering the application
  useEffect(() => {

    const requestUser = async () => {
      
      const { data } = await verifyToken(accessToken)

      if(!data.status){
        
        dispatch({
          type: 'UNAUTHENTICATED'
        })

      } else {

        dispatch({
          type: VERIFIED_TOKEN,
          payload: { user: data.user },
        })

      }

      // setShowSplashScreen(false)

    }

    if (accessToken) {
      requestUser()
    } 

  }, [])

  return (<>{props.children}</>)
}

export default AuthInit
